import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-business-center',
  templateUrl: './business-center.component.html',
  styleUrls: ['./business-center.component.scss']
})
export class BusinessCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
